/* jshint esversion: 6 */
import { guest, auth } from './middleware.js';
import { LOGIN_DIR } from './index';

import Login from '@/components/views/Login';
import Register from '@/components/views/Register';
import UpgradeChofer from '@/components/views/UpgradeChofer';
import ResetPassword from '@/components/views/ResetPassword';
import SelectPromotion from '@/components/views/SelectPromotion';
import Home from '@/components/views/Home';
import Profile from '@/components/views/Profile';
import Historial from '@/components/views/Historial';
import Promotions from '@/components/views/Promotions';
import AccountMovements from '@/components/views/AccountMovements';
import Terms from '@/components/views/Terms';
import ChatView from '@/components/views/Chat';
import ReservaOk from '@/components/views/ReservaOk';
import ReservaError from '@/components/views/ReservaError';
import Reservas from '@/components/views/Reservas';
import PublicTariffEstimate from '@/components/views/PublicTariffEstimate';

export default [
    {
        path: '/home',
        name: 'home',
        beforeEnter: auth,
        component: Home
    },
    {
        path: '/login',
        name: 'login',
        beforeEnter: guest,
        component: Login,
        meta: {
            title: 'Iniciar sesión'
        }
    },
    {
        path: '/register',
        name: 'register',
        beforeEnter: guest,
        component: Register,
        meta: {
            title: 'Registrarse'
        }
    },
    {
        path: '/upgrade-chofer',
        name: 'upgrade-chofer',
        component: UpgradeChofer,
        meta: {
            title: 'Registrarme como chofer'
        }
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        beforeEnter: guest,
        component: ResetPassword,
        props: true,
        meta: {
            title: 'Olvidé mi contraseña'
        }
    },
    {
        path: '/reset-password/:token',
        name: 'reset-password-confirm',
        beforeEnter: guest,
        component: ResetPassword,
        props: true
    },
    {
        path: '/profile',
        name: 'profile',
        component: Profile,
        meta: {
            title: 'Mi perfil'
        }
    },
    {
        path: '/select-promotion/:zona/:viaje',
        name: 'select-promotion',
        component: SelectPromotion,
        props: true
    },
    {
        path: '/historial',
        name: 'historial',
        component: Historial,
        meta: {
            title: 'Historial de viajes'
        }
    },
    {
        path: '/promotions',
        name: 'promotions',
        component: Promotions,
        meta: {
            title: 'DESCUENTOS'
        }
    },
    {
        path: '/movements',
        name: 'movements',
        component: AccountMovements,
        meta: {
            title: 'Cuenta corriente'
        }
    },
    {
        path: '/terms',
        name: 'terms',
        component: Terms,
        meta: {
            title: 'Términos y condiciones'
        }
    },
    {
        path: '/cotizacion',
        name: 'cotizacion',
        component: PublicTariffEstimate,
        meta: {
            title: 'Cotizar viaje'
        }
    },
    {
        path: '/chat/:id?',
        name: 'chat',
        component: ChatView,
        props: true
    },
    {
        path: '/reserva-ok',
        name: 'reserva-ok',
        beforeEnter: auth,
        component: ReservaOk,
        meta: { title: 'Reserva' }
    },
    {
        path: '/reserva-error',
        name: 'reserva-error',
        beforeEnter: auth,
        component: ReservaError,
        meta: { title: 'Reserva' }
    },
    {
        path: '/reservas',
        name: 'reservas',
        beforeEnter: auth,
        component: Reservas,
        meta: { title: 'Reservas' }
    },
    {
        path: '/',
        redirect: {name: LOGIN_DIR}
    }
];



// WEBPACK FOOTER //
// ./src/router/routes.js